import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../../../assets/css/student/NgoScreen/NgoAbout.css';

const AboutSection = () => {
  const points = [
    {
      number: '1',
      text: 'Every case is <strong>verified on-ground</strong> by our partner NGOs before reaching donors.',
    },
    {
      number: '2',
      text: 'Donations go <strong>directly to educational institutes</strong>, not cash handouts.',
    },
    {
      number: '3',
      text: '<strong>Payment proof uploaded</strong> by donor for full transparency and admin monitoring.',
    },
    {
      number: '4',
      text: '<strong>Real-time impact tracking</strong> so donors see exactly who they\'re helping.',
    },
  ];

  return (
    <section className="about-section" id="about">
      <Container>
        <Row className="align-items-start g-5">

          {/* Left */}
          <Col lg={7}>
            <span className="about-section-label">About the Program</span>
            <h2 className="about-section-title">
              Transparent Education<br />Funding at Scale
            </h2>
            <p className="about-section-desc">
              Our platform connects NGOs with students in need to ensure donations
              go to deserving cases transparently. Every rupee is tracked from
              donor to institute.
            </p>
            <a href="#how-it-works" className="about-btn-primary">
              Explore the Process →
            </a>
          </Col>

          {/* Right */}
          <Col lg={5}>
            <Card className="about-info-card">
              <Card.Body className="p-4">
                <h5 className="about-info-card-title">📋 Why We're Different</h5>
                {points.map((point, index) => (
                  <div className="about-point" key={index}>
                    <div className="about-point-dot">{point.number}</div>
                    <p
                      className="about-point-text"
                      dangerouslySetInnerHTML={{ __html: point.text }}
                    />
                  </div>
                ))}
              </Card.Body>
            </Card>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;